import { render, staticRenderFns } from "./SkuType.vue?vue&type=template&id=9e299844"
import script from "./SkuType.vue?vue&type=script&lang=js"
export * from "./SkuType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports